import GameDetailsOverlay from '../components/GameDetailsOverlay/GameDetailsOverlay';

export default function GameDetailsPage({ game, onClose = () => {}, onShare = () => {}, onPlay = () => {} }) {
  return <GameDetailsOverlay game={game} onClose={onClose} onShare={onShare} onPlay={onPlay} />;
}
